// extracted by mini-css-extract-plugin
export default {"section":"Section_section__Njevv","header":"Section_header__MVsw5","icon":"Section_icon__NIIcc","add":"Section_add__zyuWM"};